'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var html = document.querySelector('html');
  var activeClass = 'age-Verification-active';
  var ageBanner = el;
  var cookieClose = context.getElement('.' + context.className + '_Close');
  var cookieName = ageBanner.dataset.cookieName;
  var listeners = (0, _create2.default)(_helpers.Listeners);

  ageBanner.classList.add(activeClass);
  html.style.overflow = 'hidden';

  if (_jsCookie2.default.get(cookieName) === 'true') {
    removeNotificationBar();
  }

  listeners.add(cookieClose, 'click', removeNotificationBar);

  function removeNotificationBar() {
    ageBanner.classList.remove(activeClass);
    _jsCookie2.default.set(cookieName, 'true');
    html.style.overflow = null;
  }
}